'use client';

import type { LinkClickBody } from '@sweetistics/contracts';
import { createTrpcClient } from '@/lib/trpc/client';

type RecordLinkClickArguments = Pick<LinkClickBody, 'url' | 'shortUrl' | 'source' | 'context'>;

let cachedClient: ReturnType<typeof createTrpcClient> | null = null;

const getTrpcClient = () => {
  if (!cachedClient) {
    cachedClient = createTrpcClient();
  }
  return cachedClient;
};

/**
 * Fire-and-forget recorder for link clicks using the utilities tRPC router.
 * Errors are swallowed so link tracking never blocks the user interaction.
 */
export function recordLinkClick({ url, shortUrl, source, context }: RecordLinkClickArguments) {
  try {
    const client = getTrpcClient();
    client.utilities.recordLinkClick
      .mutate({
        url,
        ...(shortUrl ? { shortUrl } : {}),
        ...(source ? { source } : {}),
        ...(context ? { context } : {}),
      })
      .catch(() => null);
  } catch {
    // Swallow errors; click tracking is best-effort.
  }
}
